import React from 'react'
import { FormMetadata } from './Types'
import { FeedbackModalMetricsPublisher } from '../../utils/metrics'
import { ErrorBoundary } from '../ErrorBoundary'
import FeedbackForm from './FeedbackForm'
import { getInternalChromeConfig } from '../../utils/functions'

interface FeedbackModalInterface {
  namespaceMetadata?: (FormMetadata | undefined)[]
}

export const FeedbackModal: React.FC<FeedbackModalInterface> = ({ namespaceMetadata }) => {
  const hasNamespaceMetadata = Array.isArray(namespaceMetadata) && !!namespaceMetadata[0]
  const { locale, deviceType } = getInternalChromeConfig()
  const isMobile = deviceType === 'mobile'

  if (!hasNamespaceMetadata) {
    return null
  }

  return (
    <ErrorBoundary anchorId="feedback-modal-anchorId" mobileView={isMobile} customMetricsPublisher={FeedbackModalMetricsPublisher}>
      <FeedbackForm namespaceMetadata={namespaceMetadata as FormMetadata[]} isMobile={isMobile} locale={locale} />
    </ErrorBoundary>
  )
}
